import { DefaultLegendContentProps, LegendProps } from 'recharts';
import { Box } from '@mui/material';

import { Typography } from '../typography';
import { Tooltip } from '../tooltip';

export const renderLegend: LegendProps['content'] = (props: DefaultLegendContentProps) => {
  const { payload = [], name = '' } = props;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
      {payload.map((item, index) => (
        <Tooltip key={`${index}-${name}`} title={name}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              flexGrow: 0,
            }}
          >
            <Box
              sx={{
                width: 16,
                height: 16,
                backgroundColor: item.color,
                marginRight: (theme) => theme.spacing(1),
                borderRadius: (theme) => theme.shape.borderRadius / 4,
                flexShrink: 0,
              }}
            ></Box>

            <Typography
              variant='body2'
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              color='text.secondary'
            >
              {name}
            </Typography>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};
